import useModule from "../../../hooks/useModule";
import TransformRecordEditDrawer from "../../../components/Drawers/Records/TransformRecordEditDrawer";
import SkeletonLoader from "../../../elements/SkeletonLoader";
import { useState } from "react";
import Constants from "../../../utils/Constants";

const FeedbackTransformDrawer = ({
  open,
  currentData,
  loading,
  onSave,
  onClose,
}: {
  open: boolean;
  loading?: boolean;
  currentData?: any;
  onSave: (data: any) => void;
  onClose: () => void;
}) => {
  const { module: targetModule, modulesLoading: targetModuleLoading } =
    useModule(Constants.SPRINTS_ISSUES_API_NAME);
  const { module: sourceModule, modulesLoading: sourceModuleLoading } =
    useModule("Feedback");

  const [error, setError] = useState<{
    error: string;
    clear: () => void;
  }>();

  if (targetModuleLoading || sourceModuleLoading) {
    return <SkeletonLoader />;
  }
  if (!targetModule || !sourceModule) {
    return null;
  }

  return (
    <>
      <TransformRecordEditDrawer
        open={open}
        // @ts-ignore
        dataTransform={{
          SourceModule: sourceModule.APIName,
          TargetModule: targetModule.APIName,
          Fields: [],
        }}
        sourceModule={sourceModule}
        targetModule={targetModule}
        currentData={currentData}
        onSaveRecord={saveRecord}
        onClose={() => {
          error?.clear();
          onClose();
        }}
        loading={loading}
        error={error}
        clearError={clearError}
      />
    </>
  );

  function saveRecord(values: any) {
    if (!values) return;

    const requiredFields = targetModule?.Fields.filter(
      (field) => field.Required
    );

    const missingFields = requiredFields?.filter(
      (field) => !values[field.APIName]
    );

    if (missingFields?.length) {
      return setError({
        error: `Please fill in the required fields: ${missingFields
          .map((field) => field.APIName)
          .join(", ")}`,
        clear: () => setError(undefined),
      });
    }
    onSave({ ...values, _RecordName: currentData?._RecordName });
  }

  function clearError() {
    setError(undefined);
  }
};

export default FeedbackTransformDrawer;
